import { customShadows } from '@/styles/minimalCustomShadows';
import { typography } from '@/styles/typography';
import { alpha, colors, createTheme, responsiveFontSizes } from '@mui/material';
import { shadeColor } from '../utils/colors';

// Create a theme for the Hub
// This is based on the primary color
// isMin is to tell if we are in the v2 of the Hub UI using Minimal UI theme

function createHubTheme(color) {
  const theme = createTheme({
    spacing: (factor) => `${0.5 * factor}rem`,
    palette: {
      default: {
        main: colors.grey[500],
        lightest: colors.grey[100],
        dark: 'rgba(0, 0, 0, 0.87)',
      },
      primary: {
        main: color,
        dark: shadeColor(color, 110), //darken primary 10%
        light: shadeColor(color, 10),
        lighter: shadeColor(color, 5),
        alpha: {
          lightest: alpha(color, 0.05),
          lighter: alpha(color, 0.1),
        },
        cisBlue: '#040059',
        cisBlueDark: '#00447a',
        cisBlueLight: '#e9f4fd',
        lightBlue: '#5485fc',
      },
      secondary: {
        main: '#ff8806',
        light: '#ffad32', //lighten secondary 20%
        lightest: '#FFF4E5',
      },
      tertiary: {
        main: '#4f88fc',
      },
      charcoal: {
        main: '#333333',
        light: '#666666',
      },
      success: {
        main: '#4aa148',
        lightest: '#EDF7ED',
      },
      error: {
        main: '#c91319',
      },
      background: {
        default: '#fff',
        card: '#e5eff7',
        modal: '#f5f6f8',
      },
      bgLightBlue: {
        default: '#e5eff7',
      },
      white: {
        main: '#fff',
      },
      grey: {
        main: colors.grey[700],
        lighter: colors.grey[500],
      },
      border: colors.grey[300],
      neutrals: {
        light: colors.grey[200],
        medium: colors.grey[500],
        dark: colors.grey[700],
        darkest: colors.grey[900],
      },
      text: {
        warning: '#906c1f',
        secondary: colors.grey[500],
        tertiary: '#6B7280',
      },
      neutralButton: {
        main: colors.grey[500],
        light: colors.grey[300],
        dark: colors.grey[700],
        contrastText: colors.grey[50],
      },
      newDesign: {
        dataTable: {
          columns: '#FFF',
          columnsText: '#1C252E',
        },
      },
    },
    typography,
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: { color: 'red' },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
        },
      },
      MuiAlert: {
        styleOverrides: {
          standardInfo: {
            backgroundColor: '#ebf1fc',
            color: '#002c9c',
          },
        },
      },
    },
    customShadows: customShadows(color),
  });
  return responsiveFontSizes(theme);
}

export default createHubTheme;
